import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppStateService } from '../state/app-state.service';
import { AppPages } from '../state/app-page';
import { first, map, tap } from 'rxjs/operators';

@Injectable()
export class NavProductsGuard implements CanActivate {
  constructor(private readonly appService: AppStateService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.appService.ready$.pipe(
      first(ready => ready),
      map(() => this.appService.isProductsPageEnabled()),
      tap(available => {
        if (!available) {
          this.navigateToEnabledPage();
        }
      })
    );
  }

  /**
   * Attempts to navigate to the next available page in the checkout process. If nothing is available nothing happens.
   */
  private navigateToEnabledPage() {
    const nextBestPage = this.appService.nextEnabledCheckoutPage(AppPages.products);
    if (nextBestPage) {
      this.router.navigate([nextBestPage.navPath]);
    }
  }
}
